import { render, staticRenderFns } from "./AutomaticRating.vue?vue&type=template&id=22a9c8d5&scoped=true&"
import script from "./AutomaticRating.vue?vue&type=script&lang=js&"
export * from "./AutomaticRating.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticRating.vue?vue&type=style&index=0&id=22a9c8d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a9c8d5",
  null
  
)

export default component.exports